import React from 'react'
import { BLOCKS } from '@contentful/rich-text-types'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { DocumentOutlineSection, H } from 'react-document-section'

import { getPlainTextFromReactNode } from 'utils/react'

import {
  container,
  textSection,
  iconWrapper,
  icon as iconStyle,
  title as titleStyle,
  description as descriptionStyle,
} from './CompactUniqueSellingPoint.module.scss'

export interface CompactUniqueSellingPointQueryType {
  icon: EF.AssetFileNode
  title: string
  description: EF.RTFRawQueryResponse
}

interface CompactUniqueSellingPointProps {
  icon: { file: { url: string } }
  title: string
  description: EF.RTFRawQueryResponse
}

const renderNull = () => null

const renderDescriptionRTF = (description: EF.RTFRawQueryResponse) => {
  return renderRichText(description, {
    /* eslint-disable react/display-name */
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => {
        const text = getPlainTextFromReactNode(children)
        if (!text) {
          // There's no content, so don't return a <p>
          return null
        }
        return <p className={descriptionStyle}>{text}</p>
      },
      // We don't support anything but text here. Unfortunately, due to a misconfiguration of
      // the field in Contentful some descriptions contain lists.
      [BLOCKS.LIST_ITEM]: renderNull,
      [BLOCKS.OL_LIST]: renderNull,
      [BLOCKS.UL_LIST]: renderNull,
    },
    /* eslint-enable react/display-name */
  })
}

const CompactUniqueSellingPoint = ({
  icon,
  title,
  description,
}: CompactUniqueSellingPointProps) => {
  return (
    <DocumentOutlineSection title={title}>
      <div className={container}>
        <div className={iconWrapper}>
          <img
            className={iconStyle}
            src={icon.file.url}
            alt=""
            role="presentation"
          />
        </div>
        <div className={textSection}>
          <H className={titleStyle} />
          {renderDescriptionRTF(description)}
        </div>
      </div>
    </DocumentOutlineSection>
  )
}

export default CompactUniqueSellingPoint
